import { render, staticRenderFns } from "./OrganisationSecurity.vue?vue&type=template&id=d9e585f8&scoped=true&"
import script from "./OrganisationSecurity.vue?vue&type=script&lang=js&"
export * from "./OrganisationSecurity.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationSecurity.vue?vue&type=style&index=0&id=d9e585f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9e585f8",
  null
  
)

export default component.exports